import { useTranslation } from 'react-i18next';

import styles from './ViewerHelpTextBlocks.module.scss';

export default function ViewerHelpTextBlocks() {
    const { t } = useTranslation();

    return (
        <div className={styles.infoTip}>
            <h2>{t('organisms.imageViewer.howToUse')}</h2>
            <p>{t('organisms.imageViewer.magnifyer')}</p>
            <p>
                {t('organisms.imageViewer.clickviewer')}
                <br />
                {t('organisms.imageViewer.swipeviewer')}
                <br />
                {t('organisms.imageViewer.arrowkeyviewer')}
            </p>
        </div>
    );
}
